export default {
  applyFilter: function (state, params) {
    if (params.startDate !== null) {
      localStorage.setItem('filter.start_date', params.startDate)
      state.startDate = params.startDate
    }

    if (params.endDate !== null) {
      localStorage.setItem('filter.end_date', params.endDate)
      state.endDate = params.endDate
    }
  }
}
